export const RocketPurpleAnimate = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_5432_6378)">
      <rect x="4" y="4" width="40" height="40" rx="20" fill="#EEE9FF" />
      <rect
        x="4.5"
        y="4.5"
        width="39"
        height="39"
        rx="19.5"
        stroke="url(#paint0_linear_5432_6378)"
      />
      <g clipPath="url(#clip0_5432_6378)">
        <path
          d="M15.5658 28.8986C14.8418 29.8983 14.3222 31.031 14.0367 32.2319C13.9821 32.471 13.9891 32.72 14.0571 32.9556C14.125 33.1912 14.2516 33.4058 14.4251 33.5791C14.5985 33.7525 14.8131 33.879 15.0488 33.9468C15.2844 34.0146 15.5334 34.0215 15.7725 33.9669C16.9715 33.681 18.1025 33.1616 19.1008 32.4386C19.5703 31.9698 19.8342 31.3337 19.8347 30.6703C19.8352 30.0069 19.5721 29.3705 19.1033 28.9011C18.6346 28.4316 17.9985 28.1676 17.3351 28.1672C16.6717 28.1667 16.0353 28.4298 15.5658 28.8986ZM17.9225 31.2561C17.2508 31.6862 16.5213 32.0185 15.7558 32.2427C15.9804 31.4774 16.3126 30.7479 16.7425 30.0761C16.8997 29.9243 17.1102 29.8403 17.3287 29.8422C17.5472 29.8441 17.7562 29.9317 17.9107 30.0862C18.0652 30.2407 18.1528 30.4497 18.1547 30.6682C18.1566 30.8867 18.0726 31.0972 17.9208 31.2544L17.9225 31.2561ZM29 21.0836C29 21.6361 28.7805 22.166 28.3898 22.5567C27.9991 22.9474 27.4692 23.1669 26.9167 23.1669C26.3641 23.1669 25.8342 22.9474 25.4435 22.5567C25.0528 22.166 24.8333 21.6361 24.8333 21.0836C24.8333 20.531 25.0528 20.0011 25.4435 19.6104C25.8342 19.2197 26.3641 19.0002 26.9167 19.0002C27.4692 19.0002 27.9991 19.2197 28.3898 19.6104C28.7805 20.0011 29 20.531 29 21.0836ZM31.4767 14.0002C29.4935 13.9884 27.5344 14.4338 25.7512 15.3018C23.9681 16.1698 22.409 17.4371 21.195 19.0052C19.8709 19.051 18.5723 19.3816 17.3875 19.9744C16.0135 20.6071 14.8919 21.683 14.2025 23.0294C14.0407 23.405 13.975 23.8151 14.0114 24.2224C14.0478 24.6298 14.1851 25.0217 14.4108 25.3627C14.6387 25.7121 14.9502 25.9991 15.3171 26.1978C15.6839 26.3964 16.0945 26.5003 16.5117 26.5002H18.5833C19.3557 26.504 20.0954 26.8124 20.6416 27.3586C21.1878 27.9048 21.4963 28.6445 21.5 29.4169V31.4886C21.4997 31.9056 21.6034 32.3161 21.8017 32.6829C22.0001 33.0497 22.2867 33.3613 22.6358 33.5894C22.9769 33.8152 23.3688 33.9524 23.7761 33.9888C24.1835 34.0252 24.5935 33.9595 24.9692 33.7977C26.3156 33.1084 27.3915 31.9867 28.0242 30.6127C28.617 29.4279 28.9475 28.1293 28.9933 26.8052C30.564 25.5881 31.8328 24.0252 32.7011 22.2379C33.5694 20.4506 34.0139 18.4872 34 16.5002C33.999 16.1702 33.9329 15.8437 33.8055 15.5393C33.678 15.2349 33.4917 14.9586 33.2573 14.7264C33.0229 14.4941 32.7449 14.3104 32.4394 14.1858C32.1338 14.0612 31.8066 13.9981 31.4767 14.0002ZM17.6217 24.8336H16.5117C16.3707 24.8346 16.2318 24.8 16.108 24.7328C15.9841 24.6656 15.8793 24.5681 15.8033 24.4494C15.7287 24.3391 15.6831 24.2119 15.6707 24.0793C15.6583 23.9468 15.6796 23.8132 15.7325 23.6911C16.2694 22.707 17.113 21.9252 18.135 21.4644C18.663 21.1996 19.2205 20.9982 19.7958 20.8644C18.9675 22.128 18.2405 23.4552 17.6217 24.8336ZM26.5383 29.8652C26.0776 30.8869 25.2961 31.7304 24.3125 32.2677C24.1902 32.3207 24.0565 32.342 23.9238 32.3296C23.7911 32.3172 23.6637 32.2716 23.5533 32.1969C23.4346 32.1209 23.3371 32.0161 23.2699 31.8922C23.2027 31.7684 23.1681 31.6295 23.1692 31.4886V30.3786C24.5475 29.7597 25.8747 29.0327 27.1383 28.2044C27.0037 28.7798 26.8014 29.3373 26.5358 29.8652H26.5383ZM26.6508 26.5152C25.5232 27.2984 24.3327 27.9872 23.0917 28.5744C22.9222 27.6645 22.4812 26.8272 21.8267 26.1727C21.1722 25.5182 20.3349 25.0772 19.425 24.9077C20.0126 23.6678 20.7016 22.4785 21.485 21.3519C24.2917 17.4369 27.2 15.7894 31.5 15.6669C31.717 15.6668 31.9255 15.7514 32.0811 15.9027C32.2368 16.0539 32.3272 16.26 32.3333 16.4769C32.2108 20.8002 30.5633 23.7086 26.6483 26.5152H26.6508Z"
          fill="#5622FF"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_5432_6378"
        x="0"
        y="0"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_5432_6378"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.470588 0 0 0 0 0.305882 0 0 0 0 1 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5432_6378"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5432_6378"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_5432_6378"
        x1="24"
        y1="4"
        x2="24"
        y2="44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BBA7FF" />
        <stop offset="1" stopColor="#BBA7FF" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_5432_6378">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(14 14)"
        />
      </clipPath>
    </defs>
  </svg>
);
